import {
  ANALYTICS_CHANGE_CLIENT_FILTER,
  ANALYTICS_CHANGE_FILTER,
  ANALYTICS_FETCH,
  ANALYTICS_FETCH_BY_CASE_FAILED,
  ANALYTICS_FETCH_BY_CASE_SUCCESS,
  ANALYTICS_FETCH_FAILED,
  ANALYTICS_FETCH_SUCCESS
} from '../mutations/available'
import {caseServiceLogService} from '../../application'
import {RequestState} from "../../requestState";
import {dataTablePaginationToOffsetAndLimit} from '../../helpers/pagination'


async function analyticsFetchInternal({commit, state}) {
  commit(ANALYTICS_FETCH);

  let filter = state.analytics.filter;
  let title = filter.title;
  if (title) {
    title = title.trim()
  }

  let request = {
    filterMode: filter.filterMode,
    title: title,
    clientIds: filter.clientIds,
    serviceIds: filter.serviceIds,
    dateRange: filter.dateRange,
    events: filter.events,
    pagination: dataTablePaginationToOffsetAndLimit(state.analytics.filter.pagination),
    metaFilters: filter.metaFilters
  };

  return caseServiceLogService
    .getFiltered(request)
    .then(response => {
      commit(ANALYTICS_FETCH_SUCCESS, response)
    })
    .catch(e => {
      commit(ANALYTICS_FETCH_FAILED, e);
      throw e
    })
}

const analyticsFetchInternalDebounced = _.debounce(analyticsFetchInternal, 250);

export async function analyticsFetch({dispatch, commit, state}) {
  return analyticsFetchInternalDebounced({dispatch, commit, state})
}

export async function updateAnalyticsForCase({dispatch, commit, state}, {caseId}) {
  if (state.analytics.requestState !== RequestState.Success) {
    return false
  }

  let filter = state.analytics.filter;

  let request = {
    title: filter.title,
    filterMode: filter.filterMode,
    caseId: caseId, // force only one case fetch
    clientIds: filter.clientIds,
    serviceIds: filter.serviceIds,
    dateRange: filter.dateRange,
    events: filter.events,
    pagination: {
      offset: 0,
      limit: 1
    },
    metaFilters: filter.metaFilters
  };

  return caseServiceLogService
    .getFiltered(request)
    .then(response => {
      commit(ANALYTICS_FETCH_BY_CASE_SUCCESS, {response: response, caseId: caseId})
    })
    .catch(e => {
      commit(ANALYTICS_FETCH_BY_CASE_FAILED, e);
      throw e
    })
}

export async function changeAnalyticsFilter({state, commit, dispatch}, filterDelta) {
  const oldFilters = _.cloneDeep(state.analytics.filter);
  commit(ANALYTICS_CHANGE_FILTER, filterDelta);

  if (_.isEqual(oldFilters, state.analytics.filter)) {
    return
  }

  dispatch('analyticsFetch')
}

export async function changeAnalyticsClientFilter({commit, dispatch}, filterDelta) {
  commit(ANALYTICS_CHANGE_CLIENT_FILTER, filterDelta);
}



// WEBPACK FOOTER //
// ./src/store/actions/analytics.js